import AboutExp from './AboutExp';

export default AboutExp;
